import { OrderOfferImage } from "tsi-common-react/src/components/OrderOfferImage/index";
import { createOrderOfferTemplate } from "tsi-common-react/src/templates/OrderOfferTemplate";

import { OrderOffer } from "../apps/checkout/OrderOffer";

export const Template = createOrderOfferTemplate({
    OrderOffer,
    OrderOfferImage,
});
